import axios from "axios";
import { localStorageKey } from "../constant/strings";
import { base_url } from "./api";

const apiClient = axios.create({
  baseURL: base_url, //http://localhost:3000
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(localStorageKey.authToken);
  console.log("token", token);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  },
);

export default apiClient;
